import * as angular from 'angular';
import ProductUpdatesView from './ProductUpdatesView.html';
import { ProductUpdatesController } from './ProductUpdatesController';
export const productUpdatesStateName = 'auth.application.productUpdates';
export default angular
    .module('productUpdates', ['ui.router'])
    .controller('ProductUpdatesController', ProductUpdatesController)
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state(productUpdatesStateName, {
            url: '/application/product-updates',
            views: {
                '@auth.application': {
                    template: ProductUpdatesView,
                    controller: 'ProductUpdatesController',
                    controllerAs: '$ctrl',
                },
            },
        });
    }]).name;
